import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "clearfix" };
const _hoisted_2 = { class: "clearfix no-margin-sm left10 right-10" };
const _hoisted_3 = {
    key: 0,
    name: "newSnapshot"
};
const _hoisted_4 = {
    key: 1,
    name: "apiRequest"
};
const _hoisted_5 = {
    key: 2,
    name: "systemOffline"
};
const _hoisted_6 = { class: "clearfix" };
const _hoisted_7 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, "System", -1 /* HOISTED */);
const _hoisted_9 = { class: "input-group top_search" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-2" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, "Date", -1 /* HOISTED */);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, "Snapshots", -1 /* HOISTED */);
const _hoisted_15 = { class: "input-group top_search" };
const _hoisted_16 = { class: "col-xs-12 col-sm-2 col-md-2" };
const _hoisted_17 = { class: "btn-group top27 bottom10 pw100" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-angle-double-left" }, null, -1 /* HOISTED */);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-angle-double-right" }, null, -1 /* HOISTED */);
const _hoisted_20 = { class: "col-xs-12 col-sm-2 col-md-2" };
const _hoisted_21 = { class: "float-end float-start-sm top27 bottom10 pw100" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_23 = { class: "hidden-xs" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_alert = _resolveComponent("b-alert");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_button = _resolveComponent("b-button");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.hasNewSnapshot)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_b_alert, {
                        modelValue: _ctx.hasNewSnapshot,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.hasNewSnapshot) = $event)),
                        variant: "success",
                        dismissible: ""
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.apiRequestTimestamp) + " New snapshot received. ", 1 /* TEXT */),
                            _createElementVNode("a", {
                                href: "#",
                                class: "white text-decoration-underline",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_ctx.viewLatestSnapshot && _ctx.viewLatestSnapshot(...args)), ["prevent"]))
                            }, "Click here"),
                            _createTextVNode(" to view latest snapshot.\r\n\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                ]))
                : _createCommentVNode("v-if", true),
            _createTextVNode(),
            (_ctx.hasApiRequest && !_ctx.hasNewSnapshot)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_b_alert, {
                        modelValue: _ctx.hasApiRequest,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.hasApiRequest) = $event)),
                        variant: _ctx.apiRequestCssClass,
                        dismissible: ""
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.apiRequestTimestamp) + " " + _toDisplayString(_ctx.apiRequestText), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "variant"])
                ]))
                : _createCommentVNode("v-if", true),
            _createTextVNode(),
            (_ctx.system && !_ctx.system.statusId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_b_alert, {
                        "model-value": true,
                        variant: "warning"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode("\r\n\t\t\t\t\tSystem Offline\r\n\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    })
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_multiselect, {
                        modelValue: _ctx.system,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.system) = $event)),
                        options: _ctx.systems,
                        "track-by": "systemId",
                        label: "displayName",
                        showLabels: false,
                        placeholder: _ctx.selectPlaceholder,
                        class: "multiselect-small",
                        disabled: _ctx.isBusy,
                        "allow-empty": false
                    }, {
                        noResult: _withCtx(() => [
                            _createTextVNode("\r\n\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "options", "placeholder", "disabled"])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createTextVNode(),
                _createVNode(_component_b_input_group, { class: "top_search" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_flat_pickr, {
                            class: "form-control",
                            modelValue: _ctx.query.measurementDate,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.query.measurementDate) = $event)),
                            config: _ctx.datePickerConfig,
                            placeholder: "Select date",
                            disabled: _ctx.isParentBusy
                        }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                        _createTextVNode(),
                        _createVNode(_component_b_input_group_append, null, {
                            default: _withCtx(() => [
                                _hoisted_12
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                })
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_multiselect, {
                        modelValue: _ctx.snapshot,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.snapshot) = $event)),
                        options: _ctx.snapshots,
                        "track-by": "measurementTime",
                        label: "measurementTimeText",
                        showLabels: false,
                        placeholder: _ctx.selectPlaceholder,
                        class: "multiselect-small",
                        disabled: _ctx.isBusy,
                        "allow-empty": false
                    }, {
                        noResult: _withCtx(() => [
                            _createTextVNode("\r\n\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "options", "placeholder", "disabled"])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                    _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                        variant: "outline-secondary",
                        onClick: _ctx.previousSnapshot,
                        class: "pw100 max-width100",
                        disabled: _ctx.isBusy,
                        title: "Go to previous snapshot."
                    }, {
                        default: _withCtx(() => [
                            _hoisted_18,
                            _createTextVNode(" \r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick", "disabled"])), [
                        [
                            _directive_b_tooltip,
                            void 0,
                            void 0,
                            { hover: true }
                        ]
                    ]),
                    _createTextVNode(),
                    _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                        variant: "outline-secondary",
                        onClick: _ctx.nextSnapshot,
                        class: "pw100 max-width100",
                        disabled: _ctx.isBusy,
                        title: "Go to next snapshot."
                    }, {
                        default: _withCtx(() => [
                            _hoisted_19
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick", "disabled"])), [
                        [
                            _directive_b_tooltip,
                            void 0,
                            void 0,
                            { hover: true }
                        ]
                    ])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                    _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                        variant: "outline-secondary",
                        onClick: _ctx.requestControllerData,
                        title: "Request latest measurement data from the controller device.",
                        class: "request-controller-data-btn",
                        disabled: !_ctx.enableRequestControllerDataButton
                    }, {
                        default: _withCtx(() => [
                            _hoisted_22,
                            _createElementVNode("span", _hoisted_23, " " + _toDisplayString(_ctx.requestControllerDataButtonText), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick", "disabled"])), [
                        [
                            _directive_b_tooltip,
                            void 0,
                            void 0,
                            { hover: true }
                        ]
                    ])
                ])
            ])
        ])
    ]));
}
